// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/connector/v1/catalog.proto" (package "c1.api.integration.connector.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ConnectorCatalogService } from "./catalog";
import type { ConnectorCatalogServiceSearchAppsForInstallationResponse } from "./catalog";
import type { ConnectorCatalogServiceSearchAppsForInstallationRequest } from "./catalog";
import type { ConnectorCatalogServiceGetResponse } from "./catalog";
import type { ConnectorCatalogServiceGetRequest } from "./catalog";
import type { ConnectorCatalogServiceConfigurationSchemaResponse } from "./catalog";
import type { ConnectorCatalogServiceConfigurationSchemaRequest } from "./catalog";
import type { ConnectorCatalogServiceSearchResponse } from "./catalog";
import type { ConnectorCatalogServiceSearchRequest } from "./catalog";
import type { ConnectorCatalogServiceGetInstallationResponse } from "./catalog";
import type { ConnectorCatalogServiceGetInstallationRequest } from "./catalog";
import type { ConnectorCatalogServiceSearchInstallationsResponse } from "./catalog";
import type { ConnectorCatalogServiceSearchInstallationsRequest } from "./catalog";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ConnectorCatalogServiceListInstallationsResponse } from "./catalog";
import type { ConnectorCatalogServiceListInstallationsRequest } from "./catalog";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.integration.connector.v1.ConnectorCatalogService
 */
export interface IConnectorCatalogServiceClient {
    /**
     * @generated from protobuf rpc: ListInstallations
     */
    listInstallations(input: ConnectorCatalogServiceListInstallationsRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceListInstallationsRequest, ConnectorCatalogServiceListInstallationsResponse>;
    /**
     * @generated from protobuf rpc: SearchInstallations
     */
    searchInstallations(input: ConnectorCatalogServiceSearchInstallationsRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceSearchInstallationsRequest, ConnectorCatalogServiceSearchInstallationsResponse>;
    /**
     * @generated from protobuf rpc: GetInstallation
     */
    getInstallation(input: ConnectorCatalogServiceGetInstallationRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceGetInstallationRequest, ConnectorCatalogServiceGetInstallationResponse>;
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: ConnectorCatalogServiceSearchRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceSearchRequest, ConnectorCatalogServiceSearchResponse>;
    /**
     * @generated from protobuf rpc: ConfigurationSchema
     */
    configurationSchema(input: ConnectorCatalogServiceConfigurationSchemaRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceConfigurationSchemaRequest, ConnectorCatalogServiceConfigurationSchemaResponse>;
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: ConnectorCatalogServiceGetRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceGetRequest, ConnectorCatalogServiceGetResponse>;
    /**
     * @generated from protobuf rpc: SearchAppsForInstallation
     */
    searchAppsForInstallation(input: ConnectorCatalogServiceSearchAppsForInstallationRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceSearchAppsForInstallationRequest, ConnectorCatalogServiceSearchAppsForInstallationResponse>;
}
/**
 * @generated from protobuf service c1.api.integration.connector.v1.ConnectorCatalogService
 */
export class ConnectorCatalogServiceClient implements IConnectorCatalogServiceClient, ServiceInfo {
    typeName = ConnectorCatalogService.typeName;
    methods = ConnectorCatalogService.methods;
    options = ConnectorCatalogService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListInstallations
     */
    listInstallations(input: ConnectorCatalogServiceListInstallationsRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceListInstallationsRequest, ConnectorCatalogServiceListInstallationsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceListInstallationsRequest, ConnectorCatalogServiceListInstallationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchInstallations
     */
    searchInstallations(input: ConnectorCatalogServiceSearchInstallationsRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceSearchInstallationsRequest, ConnectorCatalogServiceSearchInstallationsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceSearchInstallationsRequest, ConnectorCatalogServiceSearchInstallationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInstallation
     */
    getInstallation(input: ConnectorCatalogServiceGetInstallationRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceGetInstallationRequest, ConnectorCatalogServiceGetInstallationResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceGetInstallationRequest, ConnectorCatalogServiceGetInstallationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: ConnectorCatalogServiceSearchRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceSearchRequest, ConnectorCatalogServiceSearchResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceSearchRequest, ConnectorCatalogServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ConfigurationSchema
     */
    configurationSchema(input: ConnectorCatalogServiceConfigurationSchemaRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceConfigurationSchemaRequest, ConnectorCatalogServiceConfigurationSchemaResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceConfigurationSchemaRequest, ConnectorCatalogServiceConfigurationSchemaResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: ConnectorCatalogServiceGetRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceGetRequest, ConnectorCatalogServiceGetResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceGetRequest, ConnectorCatalogServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppsForInstallation
     */
    searchAppsForInstallation(input: ConnectorCatalogServiceSearchAppsForInstallationRequest, options?: RpcOptions): UnaryCall<ConnectorCatalogServiceSearchAppsForInstallationRequest, ConnectorCatalogServiceSearchAppsForInstallationResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectorCatalogServiceSearchAppsForInstallationRequest, ConnectorCatalogServiceSearchAppsForInstallationResponse>("unary", this._transport, method, opt, input);
    }
}
